module.exports = __webpack_public_path__ + "static/teo-e2d3b3624bf621c72fce8bf915af1d95.jpg";